<template>
  <div class="field">
    <label class="label">{{ label }}</label>
    <div class="control">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    label: {
      type: String,
      default: ''
    }
  }
}
</script>
